/**
 * pending-scan-store — canonical browser-local handle for the anonymous
 * pending Free Scan request.
 *
 * This is precedence source (B) for expired-link recovery: an identity this
 * browser already established, without any server guessing.
 */
const PENDING_STORAGE_KEY = "al_pending_scan";

export interface PendingScanRecord {
  scan_request_id: string;
  progress_token: string;
  email: string;
  domain?: string;
}

export function persistPendingScan(record: PendingScanRecord): void {
  try {
    localStorage.setItem(PENDING_STORAGE_KEY, JSON.stringify(record));
  } catch { /* ignore */ }
}

export function readPendingScan(): PendingScanRecord | null {
  try {
    const raw = localStorage.getItem(PENDING_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingScanRecord;
    if (!parsed || typeof parsed.scan_request_id !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingScan(): void {
  try { localStorage.removeItem(PENDING_STORAGE_KEY); } catch { /* ignore */ }
}
